module.exports = __webpack_public_path__ + "img/folios--avatar.9dbe571b.svg";